// import logo from "./logo.svg";
import styles from "./App.module.scss";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import Loader from "components/loader/Loader";
import ErrorBoundary from "ErrorBoundary";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import router from "router";
// import { routerSupport } from "routerSupport";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a 3-second delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer); // Cleanup the timeout on unmount
  }, []);
  return (
    <div className={styles.app}>
      <ErrorBoundary
        variant="full"
        errorMessage="Oops, something went wrong while fetching data. Please try again later."
      >
        <Suspense fallback={<Loader />}>
          <RouterProvider router={router} />
          {/* <RouterProvider router={routerSupport} /> */}
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default App;
